class CartTotal extends HTMLElement {
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate(event) {
    if (event.cart.errors) return;
    this.innerText = FoxTheme.Currency.formatMoney(
      event.cart.total_price,
      FoxTheme.settings.moneyFormat
    );
  }
}

customElements.define('cart-total', CartTotal);
